import React, { Component, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImage, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import {jsPDF} from 'jspdf';
import "./DataDisplayer.css"
import DataNofound from "../DataNofound/DataNofound";
import ParameterTable from "../ParameterTable/ParameterTable";
import DataTable from "./DataTable/DataTable";
import ChartBar from "../Chartbar/ChartBar";
import { Dataplot } from "./Dataplot/Dataplot";
import CustomSelector from "../../../../Main_Components/CustomSelector/CustomSelector";
import html2canvas from "html2canvas";

function DataDisplayer(props) {
    const [index, setIndex] = useState(-1);
    const [formstatus, setformstatus] = useState(false)
    const prevformstatus = React.useRef()
    const [data, setdata] = useState([])

    const export_data = (cl) => {
        let tb = document.getElementById("mydataframe")
        let a = html2canvas(tb).then(function (canvas) {
            let a = document.createElement('a');
            a.href = canvas.toDataURL("image/png", 1.0);
            a.download = props.name + ".png"
            a.click();
            return canvas
        });
        return a
    }

    const export_data_pdf = (cl) => {
        let tb = document.getElementById("mydataframe")
        let a = html2canvas(tb).then(function (canvas) {
            let imgData = canvas.toDataURL("image/png", 1.0);
            var pdf = new jsPDF();
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save("download.pdf");
            return canvas
        });
        return a
    }
    // Download Image Module
    function DownloadImage() {
        if (props.completed) {
            export_data()
        }
    }
    // Download PDF Module
    function DownloadPDF() {
        if (props.completed) {
            export_data_pdf()
        }
    }

    const formChartArea = () => {
        if ((props.formdata === undefined || (props.formdata["indicators"] === undefined))) {
            return null
        }
        else {
            if (Object.keys(props.formdata).length !== 0) {
                if (props.formdata["areas"].length > 20) {
                    return null
                }
            }
            return (props.formdata["indicators"].map((element, idx) => {
                return <ChartBar chartdata={data} formstatus={formstatus} formdata={props.formdata} indicator={element.value} group={props.formdata["areas"][0].group} name={idx} />
            }
            ))
        }
    }

    const formBoxplot = () => {
        if ((props.formdata === undefined || (props.formdata["indicators"] === undefined))) {
            return null
        }
        else {
            if (Object.keys(props.formdata).length !== 0) {
                if (props.formdata["areas"][0].group === "Επικράτεια") {
                    return null
                }
            }
            return (
                <div>
                    <Dataplot chartdata={data} formstatus={formstatus} formdata={props.formdata} group={props.formdata["areas"][0].group} />
                </div>)
        }
    }
    const disableTabs = () => {
        if (Object.keys(props.formdata).length !== 0) {
            if (props.formdata["areas"].length > 20 || props.formdata["areas"][0].group === "Επικράτεια") {
                return true;
            }
        }
    }
    React.useEffect(() => {
        if (props.completed === true && index !== 0 && formstatus === true) {
            setIndex(0)
        }
        if (formstatus === false && prevformstatus.current === true) {
            setformstatus(false)
            props.setformstatus(formstatus)
        }
        prevformstatus.current = formstatus
        props.setd(data)

    })

    return (
        <div id={"dataelem"} style={{ width: "100%" }} className={"data-table-view"}>
            <nav className={"dataoptions"}>
                <span className={index === 0 ? "dataselected datalinks" : "datalinks"}
                    onClick={() => setIndex(0)}><a style={{ color: "inherit" }} >Ραβδόγραμμα</a></span>
                <span className={index === 1 ? "dataselected datalinks" : "datalinks"}
                    onClick={() => setIndex(1)}><a >Beeswarm Plot</a></span>
                <span className={index === 2 ? "dataselected datalinks" : "datalinks"} onClick={() => setIndex(2)}><a style={{ color: "inherit" }} >Πίνακας δεδομένων</a></span>
            </nav>
            <div className={"filter-results-display"}>
                <div className={"filter-results-display--icons-data"}>
                    <FontAwesomeIcon icon={faFileImage} style={{
                        color: (props.completed) ? "#0F8DD6" : "#CED4DA", fontSize:'22px',cursor: (props.completed) ? "pointer" : "auto"}} className={'filter-results-display--icons--donwload-png'} size="lg" title={"Download png"} onClick={DownloadImage} />
                    
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: (props.completed) ? "#0F8DD6" : "#CED4DA", fontSize:'22px',cursor: (props.completed) ? "pointer" : "auto" }} className={'filter-results-display--icons--donwload-pdf'} size="lg" title={"Download pdf"} onClick={DownloadPDF} />
                </div>
                {/* <hr style={{ marginLeft: "5%", width: "90%" }} className={"data-sep"} /> */}
                <div id={"mydataframe"} className={"mydataframe-wrapper"}>
                    {Object.keys(props.formdata).length !== 0 ? <ParameterTable formdata={props.formdata} /> : <DataNofound />}
                    <div style={{ display: (index === 0) ? "block" : "none", width:"100%" }} id={"0"}>
                        {formChartArea()}
                    </div>
                    <div style={{ display: (index === 1) ? "block" : "none" }} id={"1"}>
                        {formBoxplot()}
                    </div>
                    <div style={{
                        display: (index === 2) ? "block" : "none", maxHeight: "400px",
                        width: "100%", overflow: 'auto'
                    }} id={"2"}><DataTable setCompleted={props.setCompleted} formdata={props.formdata} completed={props.completed} setdata={setdata} formstatus={formstatus} setFormStatus={setformstatus} /></div>

                </div>
            </div>
        </div>
    )
}
export default DataDisplayer;